<!-- Marge op een wrapper: ng-select kopieert zijn eigen klassen naar de dropdown aan body. -->
<div class="mb-2">
  <ng-select
    placeholder="Gebruiker zoeken.."
    [ngModel]="filtersClone.user"
    searchable="true"
    (ngModelChange)="onUserChange($event)"
    >
    @for (user of userAccountQueries.all$ | async; track user) {
      <ng-option [value]="user">
        {{ user.displayName }}
      </ng-option>
    }
  </ng-select>
</div>

<egi-app-select
  #appSelect
  (egiAppChange)="onAppChange($event)"
  [egiApp]="filtersClone.app"
  searchable="true"
  style="width: 100%"
></egi-app-select>

@if (filtersClone.isAnyActive) {
  <button
    eBtn
    color="highlight"
    size="sm"
    textColor="danger"
    icon="times"
    (click)="clear()"
    class="mt-2"
    >
    Filters wissen
  </button>
}
